import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      width: 360,
    },
    imageWrapper: {
      width: '100%',
      maxHeight: 226,
      borderRadius: Spacings.s24,
      overflow: 'hidden',

      '& img': {
        objectFit: 'cover',
      },
    },
    content: {
      marginTop: Spacings.s16,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
    },
    title: {
      fontWeight: FontWeights.semibold,
    },
  },
  { name: 'CardsSectionItem' },
);

export default useStyles;
